/**
 * PD-16475 — images sent with an issue message (the description, a CRM note
 * or Conversation reply, or a storefront message). Shared by the API and both
 * apps so the pickers refuse exactly what the server would.
 */

/**
 * Image types every browser displays. HEIC is left out on purpose: only
 * Safari renders it, and iPhones already convert photos to JPEG when a web
 * page asks for an image.
 */
export const ISSUE_IMAGE_CONTENT_TYPES: ReadonlyArray<string> = [
	'image/jpeg',
	'image/png',
	'image/gif',
	'image/webp',
];

/** The `accept` attribute for image pickers. */
export const ISSUE_IMAGE_ACCEPT = ISSUE_IMAGE_CONTENT_TYPES.join(',');

/** Largest image a message can carry: a full-resolution phone photo fits. */
export const ISSUE_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

/** Most images one message can carry. */
export const ISSUE_ATTACHMENT_MAX_PER_MESSAGE = 10;

export function isIssueImageContentType(
	contentType: string | null | undefined,
): boolean {
	if (contentType == null) {
		return false;
	}

	return ISSUE_IMAGE_CONTENT_TYPES.includes(
		contentType.split(';')[0]?.trim().toLowerCase() ?? '',
	);
}
